import { $localStorage } from "ng";

let designerUserSettings = ($localStorage.designerUserSettings = Object.assign(
  {
    overlayType: "preview"
  },
  $localStorage.designerUserSettings
));

export default designerUserSettings;
